import React from 'react';
import classes from './Footer.module.scss';

const Footer = () => {
  return (
    <footer className={classes.footer}>
      <p>© 2026 Tolulope Saliu. All Rights Reserved.</p>
    </footer>
  );
}

export default Footer;